export const DIVIDER_THICKNESS = '1px';
